import { SlotGridType } from 'api/definitions/slotdates/types';

import { SET_SELECTED_SLOT_GRID_TYPE } from 'redux/modules/slot-booking/actions/types';

export const setSelectedSlotGridType = (slotGridType: SlotGridType) => ({
  type: SET_SELECTED_SLOT_GRID_TYPE,
  slotGridType,
});
